import { useServiceWorkerUpdate } from '@/hooks/app/useServiceWorkerUpdate'
import { useToast } from '@/providers/ToastProvider'
import { useEffect, useRef } from 'react'

export function UpdateNotifier() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate()
  const { showToast } = useToast()
  const shownRef = useRef(false)

  useEffect(() => {
    if (updateAvailable && !shownRef.current) {
      shownRef.current = true
      showToast('New version available', {
        variant: 'update',
        duration: 0,
        action: { label: 'Update', onClick: () => void applyUpdate() },
      })
    }
  }, [updateAvailable, applyUpdate, showToast])

  return null
}
